import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

const MyThemeProvider = (props: any) => <ThemeProvider {...props} theme={theme} />

export default MyThemeProvider;